module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "frontmatter BookTitlePage"
  }, [_c('div', {
    staticClass: "title-block-book"
  }, [_c('h6', {
    staticStyle: {
      "margin-bottom": "-0.4em"
    }
  }), _vm._v(" "), _c('h1', {
    staticStyle: {
      "margin-bottom": "-0.4em"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "225",
      "src": "title_iii.jpg",
      "width": "300"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "imprint"
  }, [_c('p', [_c('img', {
    attrs: {
      "alt": "alt",
      "src": "logo.png"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-180fc83c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/a9781847677099_booktitlepage.vue
// module id = 60
// module chunks = 0